module.exports = __webpack_public_path__ + "static/media/daloRadius3.a553d6a4.JPG";